export default __webpack_public_path__ + "static/media/q.c2078b5e.png";